import { useLocation } from "react-router-dom";

// Resolves the nav entry the current URL sits on, so the desktop topbar and the
// mobile navbar render the same breadcrumb without each re-deriving it.
const useActiveNav = (menuData) => {
    const { pathname } = useLocation();
    const items = menuData?.panel || [];

    const active = items.find((item) => (item.exact ? pathname === item.navLink : pathname.startsWith(item.navLink))
    );

    return {
        label   : menuData?.label,
        homeLink: items[0]?.navLink || "/dashboard",
        title   : active?.title || "Dashboard"
    };
};

export default useActiveNav;
